import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import styled from "styled-components";
import PostCard from "../components/PostCard";
import { Post } from "../types/Post";
import { getPost, getReplies } from "../api/post";

const Container = styled.div`
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
`;

const Section = styled.section`
  margin-bottom: 40px;
`;

const SectionTitle = styled.h2`
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 16px;
  padding-bottom: 8px;
  border-bottom: 2px solid #e0e0e0;
`;

const ErrorMessage = styled.div`
  padding: 20px;
  background-color: #fee;
  border: 1px solid #fcc;
  border-radius: 8px;
  color: #c33;
`;

const LoadingMessage = styled.div`
  padding: 20px;
  text-align: center;
  color: #666;
`;

const NoRepliesMessage = styled.div`
  padding: 20px;
  text-align: center;
  color: #999;
`;

const PostPage: React.FC = () => {
  const { postId } = useParams<{ postId: string }>();
  const [post, setPost] = useState<Post | null>(null);
  const [replies, setReplies] = useState<Post[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchPostData = async () => {
      if (!postId) return;

      try {
        setLoading(true);
        setError(null);

        const postData = await getPost(Number(postId));
        setPost(postData);

        const repliesData = await getReplies(Number(postId), 40, 0);
        setReplies(repliesData);
      } catch (err) {
        setError(
          err instanceof Error ? err.message : "不明なエラーが発生しました"
        );
      } finally {
        setLoading(false);
      }
    };

    fetchPostData();
  }, [postId]);

  if (loading) {
    return (
      <Container>
        <LoadingMessage>読み込み中...</LoadingMessage>
      </Container>
    );
  }

  if (error) {
    return (
      <Container>
        <ErrorMessage>{error}</ErrorMessage>
      </Container>
    );
  }

  if (!post) {
    return (
      <Container>
        <ErrorMessage>ポストが見つかりませんでした</ErrorMessage>
      </Container>
    );
  }

  return (
    <Container>
      <Section>
        <PostCard post={post} />
      </Section>

      <Section>
        <SectionTitle>返信</SectionTitle>
        {replies.length === 0 ? (
          <NoRepliesMessage>
            まだ返信がありません。今すぐコメントしましょう！
          </NoRepliesMessage>
        ) : (
          replies.map((reply) => <PostCard key={reply.id} post={reply} />)
        )}
      </Section>
    </Container>
  );
};

export default PostPage;
